import { Edge, Node } from '@xyflow/react';
import {
  EDataType,
  NodeCategoryModel,
} from 'src/modules/network-configuration/models/node-data';
import { NodeModel } from 'src/modules/network-configuration/models/node-model';

import { getInfoConnected } from './node';

/**
 * When loading a project (e.g. from JSON), devices may have poe.enable = true
 * but be connected to a non-PoE port (e.g. due to a past validation bug).
 * This fixes that by setting poe.enable = false for such devices.
 */
export function sanitizePoEDevicesConnectedToNonPoEPorts<
  T extends Node<NodeModel>,
>(nodes: T[], edges: Edge[]): T[] {
  return nodes.map((node) => {
    const category = node.data?.category as NodeCategoryModel | undefined;
    if (category?.type !== EDataType.Device || !category.poe?.enable)
      return node;

    const portId = category.ports?.[0]?.id;
    if (!portId) return node;

    const { port } = getInfoConnected(node.id, portId, edges, nodes);
    if (!port || port.isPoE) return node;

    return {
      ...node,
      data: {
        ...node.data,
        category: {
          ...category,
          poe: { ...category.poe, enable: false },
        },
      },
    } as T;
  });
}
